import React, { useEffect, useRef, useState } from 'react';
import { NavLink } from "react-router-dom";
import { Link } from "@mui/material";
import { Container, Image, Navbar, Nav } from "react-bootstrap";

import { ANCLAS, ROUTES } from "../../constants/routes";

import video from "../../assets/videos/prueba.mp4";
import logo from "../../assets/images/logoAleanteHeader.svg";
import logoAleante from "../../assets/images/logoAleante.svg";

import "../../styles/components/HeaderMain.scss";


export default function HeaderMain() {
  const canvasRef = useRef<HTMLCanvasElement>(null);
  const [navbar, setNavbar] = useState(false);

  const changeBackground = () => {
    setNavbar(window.scrollY >= 50);
  };

  useEffect(() => {
    const canvas = canvasRef.current;
    const ctx = canvas?.getContext('2d');
    let position = 0;
  
    const drawImage = (image, position) => {
      if (ctx && canvas) {
        // Configurar el tamaño del canvas
        canvas.width = window.innerWidth;
        canvas.height = window.innerHeight;
  
        // Calcular las coordenadas y tamaño de la imagen
        const scale = Math.min(canvas.width / image.width, canvas.height / image.height) / 2;
        const imageWidth = image.width * scale;
        const imageHeight = image.height * scale;
        const x = position * (canvas.width - imageWidth) /1.04;
        const y = (canvas.height - imageHeight) / 1.05;
  
        // Dibujar un fondo en el lienzo
        ctx.fillStyle = '#2E3A4D';
        ctx.fillRect(0, 0, canvas.width, canvas.height);
  
        // Dibujar la imagen en el lienzo
        ctx.drawImage(image, x, y, imageWidth, imageHeight);
      }
    };
  
    // Cargar la imagen que deseas dibujar
    const image = document.createElement('img');
    image.src = `${logoAleante}`; // Reemplaza con la ruta de tu imagen
  
    // animacion de transicion de la imagen
    image.onload = () => {        
      const animate = () => {
        position += 0.01; // Ajusta la velocidad de avance de la imagen
  
        drawImage(image, position);
  
        if (position < 1) {
          requestAnimationFrame(animate);
        }
      };
  
      animate();
    };

    const handleResize = () => {
      // Volver a dibujar la imagen cuando cambie el tamaño de la pantalla
      drawImage(image, position);
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  useEffect(() => {
    window.addEventListener("scroll", changeBackground);

    return () => {
      window.removeEventListener("scroll", changeBackground);
    };
  }, []);

  return (
    <>
      <Navbar
        className={`navmenu ${navbar ? "scroll" : ""} px-3`}
        expand="md"
        variant="dark"
        fixed="top"
        collapseOnSelect
      >
        <Container fluid>
          <NavLink to={ROUTES.ROOT}>
            <Image
              src={logo}
              className='logo'
              alt="Logo laboratorio"
            />
          </NavLink>
          <Navbar.Toggle />
          <Navbar.Collapse className="justify-content-end">
            <Nav className="navmenu__nav-items">
              <Nav.Link as={NavLink} to={ROUTES.ROOT}>
                Inicio
              </Nav.Link>
              <Link
                href={ANCLAS.SERVICIOS}
                color="inherit"
                className='nav-link servicio'
              >
                Servicio
              </Link>
              <Link
                href={ANCLAS.EQUIPOS}
                color="inherit"
                className='nav-link servicio'
              >
                Instrumentación
              </Link>
              <Nav.Link as={NavLink} to={ROUTES.TEAMWORK}>
                Equipo
              </Nav.Link>
              <Nav.Link as={NavLink} to={ROUTES.OFERTA}>
                Oferta de trabajo
              </Nav.Link>
              {/* <Nav.Link as={NavLink} to={ROUTES.CONTACTO}>
                Contacto
              </Nav.Link> */}
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>
      <div className="hero">
        <video autoPlay loop muted >
          <source src={video} type="video/mp4" />
        </video>
        <canvas ref={canvasRef} className="canvas" />
      </div>
    </>
  );
};
  //   const canvas = canvasRef.current;
  //   const ctx = canvas?.getContext('2d');

  //   const drawArc = (endAngle: number) => {
  //     if (ctx && canvas) {
  //       // Configurar el tamaño del canvas
  //       canvas.width = window.innerWidth;
  //       canvas.height = window.innerHeight;

  //       // Calcular el radio y las coordenadas del centro
  //       const centerX = canvas.width / 2;
  //       const centerY = canvas.height / 2;
  //       const radius = Math.min(Math.abs(centerX), Math.abs(centerY)) - 10;

  //       // Calcular los ángulos de inicio y fin del arco
  //       const startAngle = Math.PI;

  //       ctx.clearRect(0, 0, canvas.width, canvas.height);

  //       // Dibujar el arco en el fondo
  //       ctx.fillStyle = '#2E3A4D';
  //       ctx.fillRect(0, 0, canvas.width, canvas.height);

  //       // Cambiar la operación de composición
  //       ctx.globalCompositeOperation = 'destination-out';

  //       // Dibujar el arco en el lienzo
  //       ctx.beginPath();
  //       ctx.arc(centerX, centerY, radius, startAngle, endAngle);
  //       ctx.lineWidth = 1;
  //       ctx.strokeStyle = '#ffffff'; // Color blanco
  //       ctx.stroke();

  //       // Rellenar el arco
  //       ctx.fillStyle = '#ffffff'; // Color blanco
  //       ctx.fill();

  //       // Restaurar la operación de composición
  //       ctx.globalCompositeOperation = 'source-over';
  //     }
  //   };

  //   // Calcular el ángulo final del arco (180 grados en radianes)
  //   const targetEndAngle = Math.PI * 3;
  //   const animationDuration = 1200; // Duración de la animación en milisegundos
  //   const framesPerSecond = 60;
  //   const frameDuration = 1000 / framesPerSecond;
  //   const totalFrames = Math.ceil(animationDuration / frameDuration);
  //   const frameIncrement = (targetEndAngle - Math.PI) / totalFrames;

  //   let currentFrame = 0;
  //   let currentEndAngle = Math.PI;

  //   const animate = () => {
  //     if (ctx && canvas) {
  //       drawArc(currentEndAngle);

  //       currentFrame++;
  //       if (currentFrame <= totalFrames) {
  //         currentEndAngle += frameIncrement;
  //         requestAnimationFrame(animate);
  //       }
  //     }
  //   };

  //   animate();
  // }, []);